<template>
  <label class="select optional control-label">
    {{ $t('formPackage.accommodation') }}
    <br>
  </label>
</template>
